const solicitudEditarCreacionState = {
  modalSolicitudEditarCreacion: false,
  validarGuarismo: true,
  codigoFonasaLoading: false,
  detallePrestacion: {
    codigoPrestacionPrestador: null,
    tipoPrestacion: null,
    pabellonPrestacion: null,
    glosaPrestacionPrestador: null,
    inicioVigenciaArancel: null,
    pertenenciaFonasa: null,
    codigoFonasa: null,
    itemImed: null,
    tipoProfesional: null,
    tipoUnidad: null,

    // grupoPrestacionIsapre: null,
    // codigoPrestacionIsapre: null,
    // glosaPrestacionIsapre: null,
    montoArancelPrestacion: null,
    tipoAtencion: null,
    glosaTipoArancel: null,
    glosaCentroAtencion: null,

    codigoPrestacionPrestadorErr: null,
    tipoPrestacionErr: null,
    pabellonPrestacionErr: null,
    glosaPrestacionPrestadorErr: null,
    inicioVigenciaArancelErr: null,
    pertenenciaFonasaErr: null,
    codigoFonasaErr: null,
    itemImedErr: null,
    tipoProfesionalErr: null,
    tipoUnidadErr: null,
    grupoPrestacionIsapreErr: "",
    codigoPrestacionIsapreErr: "",
    glosaPrestacionIsapreErr: "",
    montoArancelPrestacionErr: "",
    tipoAtencionErr: "",

    codigoFonasaValid: null,

    rowGuid: null,
  },
};

export default solicitudEditarCreacionState;

